<form #blockInputs="ngForm" *ngIf="!hasSourceSelection">
  <glxy-form-field class="review-request-links">
    @for (source of defaultSourceInfo; track source) {
      <mat-checkbox
        color="primary"
        [checked]="isSourceSelected(source.sourceId)"
        (change)="valueChange(source.sourceId, $event)"
      >
        {{ source.name | translate }}
      </mat-checkbox>
    }
  </glxy-form-field>
</form>

<div class="sources-subsection" *ngIf="hasSourceSelection">
  <div class="section-header">
    {{ 'EMAIL_BUILDER.REVIEW_REQUEST_LINKS_BLOCK.SOURCE_SELECTION_MODAL.HEADER' | translate }}
  </div>
  <div class="sources-subsection-header">
    <span class="maximum-sources">
      {{
        'EMAIL_BUILDER.REVIEW_REQUEST_LINKS_BLOCK.MODES.CONFIGURE_MANUALLY.MAX_SELECTIONS'
          | translate: { maxSelections: sourceSelectionLimit }
      }}
    </span>

    <div *ngIf="sourceSelectionModal">
      <button (click)="getValueFromModal()" mat-stroked-button>
        <mat-icon>edit</mat-icon>
        {{ 'COMMON.ACTION_LABELS.EDIT' | translate }}
      </button>
    </div>
  </div>
  <reviews-selected-sources-display
    [shouldFilter]="true"
    [selectedSources]="this.selectedSourceIDs()"
  ></reviews-selected-sources-display>
</div>
